/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthenticationDto } from '../models/authentication-dto';
import { authRedirectSsoLogin } from '../fn/authentication/auth-redirect-sso-login';
import { AuthRedirectSsoLogin$Params } from '../fn/authentication/auth-redirect-sso-login';
import { authRedirectSsoLogout } from '../fn/authentication/auth-redirect-sso-logout';
import { AuthRedirectSsoLogout$Params } from '../fn/authentication/auth-redirect-sso-logout';
import { authSsoAndAuthorizationInit } from '../fn/authentication/auth-sso-and-authorization-init';
import { AuthSsoAndAuthorizationInit$Params } from '../fn/authentication/auth-sso-and-authorization-init';
import { RedirectDataDto } from '../models/redirect-data-dto';

@Injectable({ providedIn: 'root' })
export class AuthenticationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authSsoAndAuthorizationInit()` */
  static readonly AuthSsoAndAuthorizationInitPath = '/api/auth/init';

  /**
   * Callback url after login on SSO server; initializes SSO: get initial refresh and access tokens by code.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authSsoAndAuthorizationInit()` instead.
   *
   * This method doesn't expect any request body.
   */
  authSsoAndAuthorizationInit$Response(params: AuthSsoAndAuthorizationInit$Params, context?: HttpContext): Observable<StrictHttpResponse<(AuthenticationDto | RedirectDataDto)>> {
    const obs = authSsoAndAuthorizationInit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Callback url after login on SSO server; initializes SSO: get initial refresh and access tokens by code.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authSsoAndAuthorizationInit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authSsoAndAuthorizationInit(params: AuthSsoAndAuthorizationInit$Params, context?: HttpContext): Observable<(AuthenticationDto | RedirectDataDto)> {
    const resp = this.authSsoAndAuthorizationInit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(AuthenticationDto | RedirectDataDto)>): (AuthenticationDto | RedirectDataDto) => r.body)
    );
  }

  /** Path part for operation `authRedirectSsoLogin()` */
  static readonly AuthRedirectSsoLoginPath = '/api/auth/sso-login';

  /**
   * Get SSO login url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRedirectSsoLogin()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRedirectSsoLogin$Response(params: AuthRedirectSsoLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authRedirectSsoLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get SSO login url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRedirectSsoLogin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRedirectSsoLogin(params: AuthRedirectSsoLogin$Params, context?: HttpContext): Observable<void> {
    const resp = this.authRedirectSsoLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authRedirectSsoLogout()` */
  static readonly AuthRedirectSsoLogoutPath = '/api/auth/sso-logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRedirectSsoLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRedirectSsoLogout$Response(params: AuthRedirectSsoLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<RedirectDataDto>> {
    const obs = authRedirectSsoLogout(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRedirectSsoLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRedirectSsoLogout(params: AuthRedirectSsoLogout$Params, context?: HttpContext): Observable<RedirectDataDto> {
    const resp = this.authRedirectSsoLogout$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<RedirectDataDto>): RedirectDataDto => r.body)
    );
  }

}
